import { Component, OnInit } from '@angular/core';
import { ElectionClient, ElectionDto, ElectionsOverviewDto } from "@shared/clients/api.generated";
import { SvgIcon } from "@valg-shared/utils/svg-icon";
import { Router } from "@angular/router";
import { DateService } from "@shared/services/date-service.service";
import { ElectionOverviewBaseComponent } from '@shared/components/election-overview-base/election-overview-base.component';

@Component({
  selector: 'valg-dk-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: [ 'landing-page.component.scss' ]
})
export class LandingPageComponent extends ElectionOverviewBaseComponent implements OnInit{
  SvgIcon = SvgIcon;

  constructor(
    private readonly electionClient: ElectionClient,
    protected override readonly router: Router,
    protected override readonly dateService: DateService) {
      super(router, dateService);
  }

  ngOnInit(): void {
    this.electionClient.getAllElections().subscribe((results: ElectionsOverviewDto) => {
      this.electionsOverview = results;
    })
  }

  public async onSelectElectionClicked(election: ElectionDto) {
    await this.router.navigate([ `./${this.electionIdentifier[election.electionType]}`, election.id ])
  }

}
